import { makeStyles } from "@material-ui/core";
import { ResponsivePie } from '@nivo/pie';
import { DashboardHeader } from "pages/admin/dashboard/components/general";
const useStyles = makeStyles((theme) => ({
  wrapChart: {
    width: '100%',
    height: 'calc(100% - 35px)'
  },
  chart: {
    width: '100%',
    height: '100%',
  }
}));

const CenteredMetric = ({ dataWithArc, centerX, centerY }) => {
  let total = 0
  dataWithArc.forEach(datum => {
    total += datum.value
  })

  return (
    <text
      x={centerX}
      y={centerY}
      textAnchor="middle"
      dominantBaseline="central"
      style={{
        fontSize: '25px',
        fontWeight: 600,
      }}
    >
      {total}
    </text>
  )
}

const data = [
  {
    "id": "s6",
    "label": "หอการค้า",
    "value": 10,
    "color": "#EDAD3D"
  },
  {
    "id": "s1y",
    "label": "ระหว่างส่งเสริม",
    "value": 15,
    "color": "#1BA0B2"
  },
  {
    "id": "s2y",
    "label": "ศึกษาลู่ทาง",
    "value": 15,
    "color": "#9956BE"
  }
]

const TypeOfVisaPieChart = ({ data /* see data tab */ }) => (
  <ResponsivePie
    data={data}
    margin={{ top: 10, right: 20, bottom: 20, left: -50 }}
    innerRadius={0.7}
    borderColor={{ from: 'color', modifiers: [['darker', '0.2']] }}
    padAngle={1}
    enableArcLinkLabels={false}
    arcLinkLabelsSkipAngle={11}
    arcLinkLabelsTextColor="#333333"
    arcLinkLabelsThickness={2}
    arcLinkLabelsColor={{ from: 'color', modifiers: [] }}
    arcLabelsRadiusOffset={0.45}
    arcLabelsTextColor={{ from: 'color', modifiers: [['brighter', '3']] }}
    colors={data.map(x => x.color)}
    layers={['arcs', 'arcLabels', 'arcLinkLabels', 'legends', CenteredMetric]}
    // tooltip={datum => {
    //   console.log(datum);

    //   console.log(datum?.datum?.label);
    //   return <div>{datum?.datum?.label}</div>;


    // }}
    legends={[
      {
        anchor: 'right',
        direction: 'column',
        justify: false,
        translateX: 0,
        translateY: -2,
        itemsSpacing: 2,
        itemWidth: 103,
        itemHeight: 17,
        itemTextColor: '#999',
        itemDirection: 'left-to-right',
        itemOpacity: 1,
        symbolSize: 17,
        symbolShape: 'circle',
        effects: [
          {
            on: 'hover',
            style: {
              itemTextColor: '#000'
            }
          }
        ]
      }
    ]}

  />)

function TypeOfVisaChart() {
  const classes = useStyles();

  return (
    <>
      <div>
        <DashboardHeader title="ประเภทคำขอ" />
      </div>
      <div className={classes.wrapChart}>

        <TypeOfVisaPieChart data={data} className={classes.chart} />
      </div>
    </>
  )
}


export default TypeOfVisaChart;